import styled from 'styled-components';

import { baseFontFamily, baseFontSize, baseLineHeight } from 'views/services/font-scheme';
import { primaryColor, baseColor } from 'views/services/color-scheme';
import backgroundImage from './assets/background-image.gif';

interface Height { height: string; }

export const Root = styled.div`
  font-family: ${baseFontFamily};
  font-size: ${baseFontSize};
  line-height: ${baseLineHeight};
  color: ${primaryColor};
  background-image: url(${backgroundImage});
  background-repeat: repeat-x;
`;

export const Layout = styled.div<Height>`
  margin: 0 auto;
  position: relative;
  width: 924px;
  height: ${p => p.height};
`;

export const Menu = styled.div`
  position: relative;
  top: 3px;
  font-size: 0.8em;
  text-align: center;
  a {
    color: ${baseColor};
    text-decoration: none;
    &:hover {
      opacity: 0.75;
    }
  }
  & > ul {
    & > li {
      display: inline-block;
      padding: 0 10px;
      border-right: 1px solid ${baseColor};
      line-height: 1;
      &:last-child {
        border-right: none;
      }
    }
  }
`;

export const Logo = styled.div`
  position: absolute;
  top: 36px;
`;

export const Company = styled.div`
  position: absolute;
  left: 54px;
  top: 33px;
  font-size: 1.5em;
`;

export const Address = styled.div`
  position: absolute;
  left: 54px;
  top: 57px;
  font-size: 0.8em;
`;

export const Tel = styled.div`
  position: absolute;
  left: 320px;
  top: 45px;
  font-size: 0.8em;
`;

export const Fax = styled.div`
  position: absolute;
  left: 320px;
  top: 57px;
  font-size: 0.8em;
`;

export const Copyright = styled.div`
  position: absolute;
  right: 0;
  top: 57px;
  font-size: 0.8em;
`;
